/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Accounting service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: dev@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BillUserEntityDto } from '../model';
// @ts-ignore
import { UserEntityDto } from '../model';
// @ts-ignore
import { UserEntityRequest } from '../model';
/**
 * EntityApiApiEntityAddUserEntityPost - axios parameter creator
 * 
 * @param {UserEntityRequest} [userEntityRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function EntityApiApiEntityAddUserEntityPostAxiosParamCreator (userEntityRequest?: UserEntityRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Entity/addUserEntity`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userEntityRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * EntityApiApiEntityConnectEntityToBillPost - axios parameter creator
 * 
 * @param {number} [billId] 
 * @param {number} [entityId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function EntityApiApiEntityConnectEntityToBillPostAxiosParamCreator (billId?: number, entityId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Entity/connectEntityToBill`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }

    if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * EntityApiApiEntityGetBillUserEntityGet - axios parameter creator
 * 
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function EntityApiApiEntityGetBillUserEntityGetAxiosParamCreator (billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Entity/getBillUserEntity`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * EntityApiApiEntityGetUserEntitiesGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function EntityApiApiEntityGetUserEntitiesGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Entity/getUserEntities`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * EntityApiApiEntityUpdateUserEntityPut - axios parameter creator
 * 
 * @param {number} [id] 
 * @param {UserEntityRequest} [userEntityRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function EntityApiApiEntityUpdateUserEntityPutAxiosParamCreator (id?: number, userEntityRequest?: UserEntityRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Entity/updateUserEntity`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (id !== undefined) {
        localVarQueryParameter['id'] = id;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userEntityRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiEntityAddUserEntityPost operation in EntityApi.
 * @export
 * @interface EntityApiApiEntityAddUserEntityPostRequest
 */
export interface EntityApiApiEntityAddUserEntityPostRequest {
    /**
     * 
     * @type {UserEntityRequest}
     * @memberof EntityApiApiEntityAddUserEntityPost
     */
    readonly userEntityRequest?: UserEntityRequest
}

/**
 * Request parameters for apiEntityConnectEntityToBillPost operation in EntityApi.
 * @export
 * @interface EntityApiApiEntityConnectEntityToBillPostRequest
 */
export interface EntityApiApiEntityConnectEntityToBillPostRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityApiApiEntityConnectEntityToBillPost
     */
    readonly billId?: number

    /**
     * 
     * @type {number}
     * @memberof EntityApiApiEntityConnectEntityToBillPost
     */
    readonly entityId?: number
}

/**
 * Request parameters for apiEntityGetBillUserEntityGet operation in EntityApi.
 * @export
 * @interface EntityApiApiEntityGetBillUserEntityGetRequest
 */
export interface EntityApiApiEntityGetBillUserEntityGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityApiApiEntityGetBillUserEntityGet
     */
    readonly billId?: number
}

/**
 * Request parameters for apiEntityGetUserEntitiesGet operation in EntityApi.
 * @export
 * @interface EntityApiApiEntityGetUserEntitiesGetRequest
 */
export interface EntityApiApiEntityGetUserEntitiesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityApiApiEntityGetUserEntitiesGet
     */
    readonly userId?: number
}

/**
 * Request parameters for apiEntityUpdateUserEntityPut operation in EntityApi.
 * @export
 * @interface EntityApiApiEntityUpdateUserEntityPutRequest
 */
export interface EntityApiApiEntityUpdateUserEntityPutRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityApiApiEntityUpdateUserEntityPut
     */
    readonly id?: number

    /**
     * 
     * @type {UserEntityRequest}
     * @memberof EntityApiApiEntityUpdateUserEntityPut
     */
    readonly userEntityRequest?: UserEntityRequest
}

/**
* 
* @param {EntityApiApiEntityAddUserEntityPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function EntityApiApiEntityAddUserEntityPost(requestParameters: EntityApiApiEntityAddUserEntityPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await EntityApiApiEntityAddUserEntityPostAxiosParamCreator(requestParameters.userEntityRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {EntityApiApiEntityConnectEntityToBillPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function EntityApiApiEntityConnectEntityToBillPost(requestParameters: EntityApiApiEntityConnectEntityToBillPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await EntityApiApiEntityConnectEntityToBillPostAxiosParamCreator(requestParameters.billId, requestParameters.entityId, options, configuration);
    const request: () => AxiosPromise<BillUserEntityDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {EntityApiApiEntityGetBillUserEntityGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function EntityApiApiEntityGetBillUserEntityGet(requestParameters: EntityApiApiEntityGetBillUserEntityGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await EntityApiApiEntityGetBillUserEntityGetAxiosParamCreator(requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<BillUserEntityDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {EntityApiApiEntityGetUserEntitiesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function EntityApiApiEntityGetUserEntitiesGet(requestParameters: EntityApiApiEntityGetUserEntitiesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await EntityApiApiEntityGetUserEntitiesGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<Array<UserEntityDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {EntityApiApiEntityUpdateUserEntityPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function EntityApiApiEntityUpdateUserEntityPut(requestParameters: EntityApiApiEntityUpdateUserEntityPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await EntityApiApiEntityUpdateUserEntityPutAxiosParamCreator(requestParameters.id, requestParameters.userEntityRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
